import { ReactNode } from "react";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { AppHeader } from "./AppHeader";
import { useLanguage } from "@/contexts/LanguageContext";
import { PWAInstallBanner, PWAInstallModal } from "@/components/pwa";
import { useBrandColor } from "@/hooks/useBrandColor";

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const { direction } = useLanguage();
  
  // Load and apply saved brand color from company settings
  useBrandColor();
  
  return (
    <SidebarProvider defaultOpen={true}>
      <div className="min-h-screen flex w-full bg-background" dir={direction}>
        <AppSidebar />
        <div className="flex-1 flex flex-col min-w-0">
          <AppHeader />
          <main className="flex-1 p-4 sm:p-6 overflow-auto pb-20">
            {children}
          </main>
          <PWAInstallBanner />
          <PWAInstallModal />
        </div>
      </div>
    </SidebarProvider>
  );
}
